export const getQuizSlugs = (quiz: any) => {
  return quiz.map((s: any) => s.slug)
}

export const getStepBySlug = (quiz: any, slug: string) => {
  const index = quiz.findIndex((step: any) => step.slug === slug)
  if (index === -1) return null

  return {
    index,
    step: quiz[index],
    count: quiz.length - 1,
    prev: quiz[index - 1]
      ? {
          index: index - 1,
          slug: quiz[index - 1].slug,
        }
      : null,
    next: quiz[index + 1]
      ? {
          index: index + 1,
          slug: quiz[index + 1].slug,
        }
      : null,
  }
}
